import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Settings } from '@stockcare-helpers/settings';
import { IDevice } from '@stockcare-models/IDevice';
import { ApplicationUpdateService } from '@stockcare-services/application-update-service/application-update.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { ThemeService } from '@stockcare-services/theme/theme.service';
import { UserStorageService } from '@stockcare-storage/user/user-storage.service';
import { Subscription } from 'rxjs';
import { LoginPinComponent } from '../login-pin/login-pin.component';
import { ConnectionService } from '@stockcare-services/connection-service/connection.service';
import { CacheService } from '@stockcare-services/cache-service/cache.service';

@Component({
  standalone: false,
  selector: 'app-login-container',
  templateUrl: './login-container.component.html',
  styleUrls: ['./login-container.component.scss'],
})
export class LoginContainerComponent implements OnInit {
  pinActive: boolean = true;
  userExists: boolean = false;
  showPinScreenAsDefault: boolean = true;
  logo: string;
  device: IDevice;
  isMobile: boolean;
  deviceType: string = '';
  enableCustomKeyboard: boolean = false;
  displayPinScreen: boolean = false;
  userName: string = '';
  sorterUserNames: string[] = [];
  filteredUserNames: string[] = [];
  recentUsersNames: string[] = [];
  searchText: string = '';
  parentSelection: string;
  subscriptions = new Subscription();
  institutionName = '';
  stockLocationName = '';
  kronosLogin: boolean = false;
  isConnected: boolean = true;
  version: string = '';

  @ViewChild(LoginPinComponent) loginPinComponent: LoginPinComponent;

  constructor(
    themeService: ThemeService,
    private applicationUpdateService: ApplicationUpdateService,
    private readonly deviceService: DeviceService,
    private readonly userStorageService: UserStorageService,
    private readonly settingsService: SettingsService,
    private connectionService: ConnectionService,
    private cacheService: CacheService
  ) {
    if (themeService.getTheme() != null) {
      this.logo = '../../../assets/img/' + themeService.getTheme().logo;
    } else {
      this.logo = '../../../assets/img/stockcare-default-logo.png';
    }

    this.userStorageService.getAllUsers().then((users) => {
      this.userExists = users?.length > 0;

      this.settingsService.getAllSettings().subscribe((settings) => {

        try 
        {
          if(settings.find((x) => x.name === Settings.KRONOS_LOGIN_SCREEN).value.indexOf('true') >= 0)
          this.kronosLogin = true;
        }catch{this.kronosLogin = false;}
                 
        if(this.kronosLogin)
        {
          this.pinActive = false;
        }
        else
        {
          if (this.userExists) {
            this.pinActive = true;
          } else {
            this.pinActive = false;
            this.loginPinComponent.viewToRender = 'password';
          }  
        }

        this.settingsService.getVersion().subscribe((ver) => {
          this.version = ver;
        });
        
      });

     
    });

    this.enableCustomKeyboard = this.settingsService.enableCustomKeyboard();

    
  }

  ngOnInit() {
    this.isMobile = this.deviceService.detectIsMobileDevice();
    this.getDeviceDetails();
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
    });
  }

  displayPinlogin() {
    if (this.loginPinComponent) {
      this.loginPinComponent.viewToRender = 'username';
      this.loginPinComponent.searchText = '';
      this.loginPinComponent.usernameKeyboard.keyboard.setInput('');
    }
    this.pinActive = true;
  }

  displayUsernamelogin() {
    this.pinActive = false;
    this.displayPinScreen = false;
    if (this.loginPinComponent) {
      this.loginPinComponent.focusInput();
      this.loginPinComponent.viewToRender = 'password';
      this.loginPinComponent.searchText = '';
    }
  }

  reloadUsernamelogin() {
    this.pinActive = true;
    this.displayPinScreen = false;
  }

  createUserPin(userName) {
    this.userName = userName;
    this.displayPinScreen = true;
  }

  forgotPin() {
    this.displayPinScreen = false;
    this.pinActive = false;
  }

  public isClinixLogo(): boolean {
    return this.logo === '../../../assets/img/medinizeLogo.png' ? true : false;
  }

  getDeviceDetails() {
    this.device = JSON.parse(localStorage.getItem('device'));

    if (this.device != null) {
      this.deviceType = this.deviceService.buildDeviceName(this?.device);
      this.stockLocationName = this.device.stockLocationName;
      this.institutionName = this.device.institutionName;
    }
  }

  reload() {
    this.applicationUpdateService.removeReloadOnLogout();
    this.cacheService.clearCache();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
